// import { environment } from 'environments';
import { Dictionary } from '@skylab-shared/types';
import { EventBus } from '../../../event';
import { Tags } from '../../../web';
import { AxiosResponse } from 'axios';
import { Interceptor, InterceptorRequestConfig, IResponse } from '../http.service';
import { isRequestTimeouted } from './timeout-request-interceptor';

export const RequestStatusCode5xxOccuredEvent = Symbol('shared:request-status-code-5xx-occured');

export function handle5xxStatusRequestInterceptor(): Interceptor {
    return {
        request: (config: InterceptorRequestConfig) => {
            if (config.taggedUrl.hasTag(Tags.Suz) || config.taggedUrl.hasTag(Tags.NotHandle5xx)) {
                const requestId = config.headers?.['X-Request-Id'] as string;
                registerAsNotHandledRequest(requestId, config.taggedUrl.tags);
            }
        },
        response: (response: AxiosResponse) => {
            const requestId = response.config?.headers?.['X-Request-Id'] as string;
            if (isRegisteredAsNotHandledRequest(requestId)) {
                unregisterFromNotHandledRequest(requestId);
            }
        },
        responseError: (error: IResponse) => {
            const requestId = error.config?.headers?.['X-Request-Id'] as string;
            if (isRegisteredAsNotHandledRequest(requestId)) {
                unregisterFromNotHandledRequest(requestId);
            } else if (!isRequestTimeouted(error) && error.response && error.response.status >= 500 && !error.config?.taggedUrl?.hasTag(Tags.OmitMessage)) {
                const errorCode = error.response.headers?.['x-subiekt123-errorcode'];
                EventBus.emit(RequestStatusCode5xxOccuredEvent, {requestId, errorCode});
            }
        }
    };
}

const notHandledRequests: Dictionary<string[]> = {};

function registerAsNotHandledRequest(id: string, tags: string[]): void {
    notHandledRequests[id] = tags;
}

function unregisterFromNotHandledRequest(id: string): void {
    delete notHandledRequests[id];
}

function isRegisteredAsNotHandledRequest(id: string): boolean {
    return Object.prototype.hasOwnProperty.call(notHandledRequests, id);
}
